import Vue from 'vue'
import es from 'vee-validate/dist/locale/es'
import VeeValidate, { Validator } from 'vee-validate'

import BootstrapVue from 'bootstrap-vue'


Vue.config.productionTip = false
es.custom = {
    history: {
        required: 'Esta Carrera requiere el puntaje de HISTORIA'
    },
    science: {
        required: 'Esta Carrera requiere el puntaje de CIENCIAS'
    }
}
Vue.use(VeeValidate, {
    fieldsBagName: 'fieldsBag'
})
Validator.localize('es', es)
Vue.use(BootstrapVue)



